import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "SliceStringNamePipe",
})
export class SliceStringNamePipe implements PipeTransform {
  transform(data: string): string {
    if (data && data.length > 20) {
      return data.slice(0, 20) + "...";
    }
    return data;
  }
}

@Pipe({
  name: "SliceTringNameBigTablePipe",
  pure: true,
})
export class SliceTringNameBigTablePipe implements PipeTransform {
  transform(data: string): string {
    if (!data) {
      return "";
    }
    return data.length > 5 ? data.slice(0, 7) + "..." : data;
  }
}